<template>
	<div class="ReTimeRange">
		<el-time-select 
			:placeholder="start_placeholder" 
			v-model="value.startDt"
		>
		</el-time-select>
		<span class="range_separator">{{range_separator}}</span>
		<el-time-select 
			:placeholder="end_placeholder" 
			v-model="value.endDt"
		>
		</el-time-select>
	</div>
</template>
<script>
	import { TimeSelect } from 'element-ui';
	export default {
		name: 'ReTimeRange',
		components: {
			[TimeSelect.name]: TimeSelect,
		},
		props: {
			value: {
				type: Object,
				default() {	return {
					startDt: '',
					endDt:''
				}; }
			},
			range_separator:{
				type:String,
				default: '-'
			},
			start_placeholder:{
				type:String,
				default: 'С'
			},
			end_placeholder:{
				type:String,
				default: 'По'
			},
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {

		},
	}
</script>
<style scoped>
	.ReTimeRange{
		display: flex;
		align-items: center;
	}
	.ReTimeRange > * {display: inline-block;}
	.ReTimeRange .range_separator{margin: 0 5px;}
</style>
